import { render } from "./RatingFaces.vue?vue&type=template&id=56bae62e&scoped=true&ts=true"
import script from "./RatingFaces.vue?vue&type=script&lang=ts"
export * from "./RatingFaces.vue?vue&type=script&lang=ts"

import "./RatingFaces.vue?vue&type=style&index=0&id=56bae62e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bae62e"]])

export default __exports__